import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';
import { API_URL } from './api';

/**
 * Sign-in is one field and one button, and it stays that way. There is no password to
 * choose, forget, reset, or store, and the link in the mail is the whole credential.
 */
export const authClient = createAuthClient({
  baseURL: API_URL,
  basePath: '/v1/auth',
  plugins: [magicLinkClient()],
});

export const { useSession, signOut } = authClient;

/**
 * Where the link should land the reader once it has been verified. Absolute, because the
 * link is verified by the API on its own origin and the redirect has to cross back to the
 * app; the server allows it because this origin is in `trustedOrigins`.
 */
export const callbackURL = (path = '/') => new URL(path, window.location.origin).toString();
